import { useSaveFinancialFile } from '@Domains/FinancialStatements';
import { useDisclosure } from '@hooks/useDisclosure';
import SaveIcon from '@mui/icons-material/Save';
import { Alert, Button, Snackbar } from '@mui/material';
import { mappingFinancialStatementsToPayload } from '@Router/FinancialStatements/utils';
import { findUserRoles } from '@Utils/roleUtils';
import { updateCompletedSection } from '@Utils/updateCompletedSection';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useProfile } from 'src/Constant/UserProfileContext/UserProfileProvider';
import { IFinancialStatementsFormValues } from '../FinancialStatementsProvider/types';
import { mappingFinancialStatementsToFormValues } from './utils';

const FinancialStatementsSaveButton = () => {
  const { getValues, reset, trigger } =
    useFormContext<IFinancialStatementsFormValues>();

  const { id = '' } = useParams();

  const [openedSnackbar, { open: openSnackbar, close: closeSnackbar }] =
    useDisclosure();
  const { refetchProgressWithUpdate, isPublished } = useProgressBar();
  const [{ loading, error }, saveFileDetails] = useSaveFinancialFile(
    Number(id)
  );
  const { user } = useProfile();

  const handleSave = async () => {
    if (user) {
      const formValues = getValues();

      const { cvupCreatorRole, cvupApproverRole } = findUserRoles(user.N_ROLES);

      const updatedCompletedSection = updateCompletedSection(
        formValues.completedSection,
        cvupCreatorRole ? { N_ROLE: cvupCreatorRole } : undefined,
        cvupApproverRole ? { N_ROLE: cvupApproverRole } : undefined
      );

      const completeFormValues = {
        ...formValues,
        completedSection: updatedCompletedSection,
        otherDescriptions: formValues.otherDescriptions || [],
      };

      const payload = mappingFinancialStatementsToPayload(completeFormValues);

      try {
        const response = await saveFileDetails({
          data: payload,
        });

        if (response) {
          const dataFormValues = mappingFinancialStatementsToFormValues(
            response.data
          );
          reset({ ...dataFormValues });
        }
      } catch (error) {
        console.error('Save error:', error);
      } finally {
        refetchProgressWithUpdate(true);
        trigger();
        openSnackbar();
      }
    }
  };

  return (
    <>
      <Button
        type="submit"
        color="inherit"
        startIcon={<SaveIcon />}
        onClick={handleSave}
        loading={loading}
        disabled={isPublished}
      >
        บันทึก
      </Button>
      <Snackbar
        open={openedSnackbar}
        autoHideDuration={2000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          severity={error ? 'error' : 'success'}
          onClose={closeSnackbar}
          sx={{
            alignItems: 'center',
            marginBottom: 6,
            '.MuiAlert-icon': { py: 1 },
            '.MuiAlert-message': { py: 1 },
          }}
        >
          {error ? 'เกิดข้อผิดพลาดในการบันทึก' : 'บันทึกสําเร็จ'}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FinancialStatementsSaveButton;
